import { BMPrimitives, BMText, useBMTheme } from "@traveloka/district-bloom";
import { Pressable, StyleSheet } from "react-native";

import BMView from "../../../components/View/BMView";
import { appendTestId } from "../../../utils";
import { MenuItemProps } from "./types";

export default function MenuItem({
  title,
  Icon,
  onClick,
  testID,
}: MenuItemProps) {
  const { BMComponents } = useBMTheme();

  const renderIcon = () => {
    if (typeof Icon === "function") {
      return (
        <Icon
          width={16}
          height={16}
          color={BMComponents.BMStyleIconInkPrimary}
          accentColor={BMComponents.BMStyleIconInkPrimary}
        />
      );
    }
    return Icon;
  };

  const renderTitle = () =>
    typeof title === "string" ? (
      <BMText variant="uiLargeLi">{title}</BMText>
    ) : (
      title
    );

  return (
    <Pressable onPress={onClick} testID={appendTestId("menu", testID)}>
      <BMView style={styles.container} align="center" row spacing="md">
        <BMView>{renderIcon()}</BMView>
        {renderTitle()}
      </BMView>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingVertical: BMPrimitives.BMSize.sm,
    paddingHorizontal: BMPrimitives.BMSize.md,
  },
});
